/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import AssertionError from 'assertion-error';

import DivViewerSource from './div-viewer-source';

/**
 * @import { IViewerSourceFactory } from '.'
 * @import { ViewerFrameFactory } from '../viewer/frame'
 * @
 */

// TODO Unit testy.
/**
 * Továrna na zdroje funkcionalit v podobě HTML image elementů.
 * @implements {IViewerSourceFactory}
 */
export default class DivViewerSourceFactory {
  /**
   * Vytvoří instanci.
   * @param {ViewerFrameFactory} frameFactory
   */
  constructor(frameFactory) {
    this.frameFactory = frameFactory;
    /** @type {HTMLElement | undefined} */
    this.parentEl = undefined;
  }

  /** @type {IViewerSourceFactory['create']} */
  create() {
    if (!this.parentEl) {
      // Zakázáno vytváření bez rodičovského elementu, jinak nemá příprava objektů v bazénu smysl.
      throw new AssertionError(`Invalid parent element ${this.parentEl}.`);
    }

    return new DivViewerSource(this.frameFactory, this.parentEl);
  }

  /** @type {IViewerSourceFactory['delete']} */
  delete(source) {
    return source.destroy();
  }

  /** @type {IViewerSourceFactory['setParentEl']} */
  setParentEl(parentEl) {
    this.parentEl = parentEl;
  }
}
